package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_10_11_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who were awakened during the first night watch shift by Falorn after he thought he saw “Buddy,” an old coworker from his days in “The Fist,” who likely intends to harm Falorn. Bigglesworth had also briefly grappled this human male before he escaped again.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes search with their dark vision, magic, and night vision goggles. Dirk thinks he finds him and casts slow on him. He appears to be an elven male or maybe a half-elf.  In any case, this man teleports away using dimension door. Tuesday transforms Bigglesworth and Caper into giant fruit bats, and they chase Not-Buddy (Anarin Conlan?). They find him and try to attack but this escape artist once again escapes our heroes’ grasp as yellow tendrils rise from the earth, immobilizing Bigglesworth.")
    }
}
